import register from '@wcd/preact-custom-element';
import { TESCookieV2 } from '../shared/cookies';
import { useContext } from './context';

export const component = ({ children, 'resource-id': resourceId, 'resource-author-id': resourceAuthorId, 'reviewer-ids': reviewerIds}) => {
  let content = '';
  let rating = 0;

  const user = TESCookieV2() || {};

  const isAuthor = user?.id === resourceAuthorId;
  let owns = false;
  let userDownloadedTheResource = false;
  const hasAlreadyWrittenReview = reviewerIds.split(',').some(id => id == user?.userId);

  const writeReviewContainer = document.getElementById('rdp-review-write__container');
  const writeButton = document.getElementById('review-write__cta');
  const writeButtonText = document.getElementById('review-write-text__cta');
  const updateButtonText = document.getElementById('review-update-text__cta')
  const cancelButton = document.getElementById('review-cancel__cta');
  const writeSection = document.getElementById('rdp-review-write__section');
  const reviewTextarea = document.getElementById('review-write__body');
  const submitButton = document.getElementById('review-submit__cta');
  const ratingContainer = document.querySelector('.rdp-review__rating');
  const ratingIcons = document.querySelectorAll('.rdp-review__rating .rating__icon')
  const reviewsGeneralError = document.getElementById('reviews-general-error');

  useContext(({ user: userResponse, downloaded }) => {
    owns = userResponse?.owns;
    userDownloadedTheResource = downloaded?.downloaded;
    if (owns || userDownloadedTheResource && !isAuthor) {
      show(writeReviewContainer);
    } else {
      writeReviewContainer?.remove();
    }
    if (hasAlreadyWrittenReview) {
      show(updateButtonText);
    } else {
      show(writeButtonText);
    }
  });

  const show = (element) =>  element?.style?.setProperty('display', 'block');
  const hide = (element) =>  element?.style?.setProperty('display', 'none');
  const onInput = (event) => { content = (event.target as HTMLTextAreaElement).value; }

  const onMouseOver = ({ target }) => selectRating(getRatingValue(target));
  const onMouseOut = () => {
    deselectRating();
    selectRating(rating);
  };

  const selectRating = (ratingValue) => {
    for (let i = 0; i < ratingValue; i++) {
      ratingIcons[i].classList.replace('icon-star-o', 'icon-star');
    }
  };

  const deselectRating = () => {
    ratingIcons.forEach(element => element.classList.replace('icon-star', 'icon-star-o'));
  };

  const onRatingClick = (event) => {
    rating = getRatingValue(event.target);
    deselectRating();
    selectRating(rating);
    openWriteSection();
  };

  const openWriteSection = () => {
    show(writeSection);
    hide(writeButton);
    reviewTextarea?.focus();
  };

  const closeWriteSection = () => {
    hide(writeSection);
    show(writeButton);
  };

  const getRatingValue = (target) => [...target.parentElement.querySelectorAll('.rating__icon')].indexOf(target) + 1;

  const validateReview = () => {
    writeSection?.classList.remove('rdp-review-write__section--has-error');
    ratingContainer?.classList.remove('rdp-review__rating--has-error');
    let validates = true;

    if (content.length === 0) {
      validates = false;
      writeSection?.classList.add('rdp-review-write__section--has-error');
    }
    if (rating === 0) {
      validates = false;
      ratingContainer?.classList.add('rdp-review__rating--has-error');
    }
    return validates;
  }

  const postReview = async () => {

    if (!validateReview()) {
      return;
    }

    const review = {
      rating: rating,
      vote: 1,
      comment: content,
      allowComments: true,
      onHold: false,
      asset: {id: Number(resourceId), type: "resource", authorId: Number(resourceAuthorId)}
    };

    const response = await fetch(`/api/review`, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(review),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const { error } = await response.json();
      reviewsGeneralError?.lastChild?.replaceWith(error);
      show(reviewsGeneralError);
    } else {
      closeWriteSection();
      hide(reviewsGeneralError);
    }
  };

  writeButton?.addEventListener('click', openWriteSection);
  cancelButton?.addEventListener('click', closeWriteSection);
  submitButton?.addEventListener('click', postReview);
  reviewTextarea?.addEventListener('input', onInput);
  ratingIcons.forEach(ratingIcon => {
    ratingIcon.addEventListener('click', onRatingClick);
    ratingIcon.addEventListener('mouseover', onMouseOver);
    ratingIcon.addEventListener('mouseout', onMouseOut);
  });

  deselectRating();
  selectRating(rating);

  return children;
};

register(component, 'write-review', [], { shadow: false });

